import { render, staticRenderFns } from "./KurccQuestionPageList.vue?vue&type=template&id=29d3fb52&scoped=true&"
import script from "./KurccQuestionPageList.vue?vue&type=script&lang=js&"
export * from "./KurccQuestionPageList.vue?vue&type=script&lang=js&"
import style0 from "./KurccQuestionPageList.vue?vue&type=style&index=0&id=29d3fb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d3fb52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
